import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-top-button',
  templateUrl: './top-button.component.html',
  styleUrls: ['./top-button.component.scss'],
})
export class TopButtonComponent {
  @Input() mainScroll: ElementRef;
  @Input() isMobile: boolean;

  constructor(public elementRef: ElementRef) {}

  goToTop() {
    this.isMobile
      ? this.mainScroll.nativeElement.scrollTo({ top: 0, behavior: 'smooth' })
      : this.mainScroll.nativeElement.scrollTo({ top: 0 });
  }
}
